import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IQuickBookOnlineSetting {
  should_import_customers: boolean;
  should_import_sub_customers: boolean;
  should_import_projects: boolean;
  create_bills_from_timesheets: boolean;
}

const saveQuickbookOnlineSetting = (postData: IQuickBookOnlineSetting) => {
  return http().post(endpoints.integrations.quickBookOnlineSaveSettings, postData);
};

export function useSaveQuickbookOnlineSetting() {
  return useMutation({ mutationFn: saveQuickbookOnlineSetting });
}
